import { Button } from '@/components/Button'

export interface CommunityBackButtonProps {
	onBack: () => void
	label?: string
}

/** Returns from a portfolio community view to the portfolio search. */
export function CommunityBackButton ({ onBack, label = 'Back to Search' }: CommunityBackButtonProps) {
	return (
		<Button
			label={label}
			iconLeft='CaretLeft'
			appearance='ghost'
			color='content2'
			size='md'
			spacesClass='spaces-community-back'
			onClick={onBack}
		/>
	)
}
